/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { RebrandingItemTO } from "./Rebrand";
export interface TenantProperty {
   brandType: string;
   brandURL: string;
   globalDomain: string;
   backgroundImg: string;
   idpTenantDomain: string;
   preLoginMessage: string;
   rebrandInfo: RebrandingItemTO[];
}

export enum BRAND_URL_TYPE {
   UNKNOWN,
   VANITY_URL,
   CUSTOM_DEFINED_URL,
   PRIVATE_LINK_URL
}
